import * as Dialog from '@radix-ui/react-dialog';
import { AlertTriangle, X } from 'lucide-react';

export default function ConfirmModal({ open, onClose, onConfirm, title, message, confirmText = 'Confirm', variant = 'danger', loading = false }) {
  const btnColor = variant === 'danger'
    ? 'bg-red-500 hover:bg-red-600'
    : 'bg-gradient-to-r from-teal-500 to-cyan-600';

  return (
    <Dialog.Root open={open} onOpenChange={(v) => { if (!v && !loading) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 animate-fade-in" />
        <Dialog.Content data-testid="confirm-modal" className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm glass-card p-6 animate-slide-up">
          <Dialog.Close data-testid="confirm-modal-close" className="absolute top-4 right-4 p-1.5 rounded-lg hover:bg-white/10 text-white/50 hover:text-white transition-colors" disabled={loading}>
            <X size={18} />
          </Dialog.Close>
          <div className="flex flex-col items-center text-center gap-3">
            {variant === 'danger' && (
              <div className="w-12 h-12 rounded-full bg-red-500/15 border border-red-500/25 flex items-center justify-center">
                <AlertTriangle size={22} className="text-red-400" />
              </div>
            )}
            <Dialog.Title className="text-lg font-bold text-white">{title}</Dialog.Title>
            <Dialog.Description className="text-sm text-white/60">{message}</Dialog.Description>
            <div className="flex gap-3 w-full mt-3">
              <button data-testid="confirm-modal-cancel" onClick={onClose} disabled={loading}
                className="flex-1 h-11 rounded-xl border border-white/15 text-white/80 text-sm font-semibold hover:bg-white/5 transition-colors">
                Cancel
              </button>
              <button data-testid="confirm-modal-confirm" onClick={onConfirm} disabled={loading}
                className={`flex-1 h-11 rounded-xl text-white text-sm font-bold transition-all ${btnColor} ${loading ? 'opacity-60' : ''}`}>
                {loading ? <div className="w-5 h-5 border-2 border-white/50 border-t-white rounded-full animate-spin mx-auto" /> : confirmText}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
